// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isValidEmailAddress = (string?: any) => {
	if (!string || typeof string !== 'string') {
		return false;
	}

	return /\S+@\S+/.test(string);
};

export default isValidEmailAddress;
